<template>

  <section class="theme-bg" id="package" ref="packagePosition">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-title">
            <h2 class="text-white">Our Pricing Plans</h2>
            <img
              src="../assets/images/white-line.png"
              alt="title-line"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-md-12 text-center">
          <swiper
            class="price-carousel"
            :modules="modules"
            :navigation="true"
            :breakpoints="{
              '@0.50': {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              '@0.75': {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              '@1.25': {
                slidesPerView: 3,
                spaceBetween: 15,
              },
              '@1.50': {
                slidesPerView: 4,
                spaceBetween: 15,
              },
            }"
            :slides-per-view="4"
            :loop="true"
            :space-between="15"
          >
            <swiper-slide v-for="(pkg, index) in packages" :key="index">
              <div class="item">
                <div class="package-box">
                  <h3>{{ pkg.type }}</h3>
                  <div class="price-box">
                    <span>$</span>
                    <h2>{{ pkg.price }}</h2>
                    <h5 class="plan-clr">
                      <span class="d-block">Year</span>
                    </h5>
                  </div>
                  <div class="price-plan text-center">
                    <ul>
                      <li>{{ pkg.feature1 }}</li>
                      <li>{{ pkg.feature2 }}</li>
                      <li>{{ pkg.feature3 }}nt</li>
                      <li>{{ pkg.feature4 }}</li>
                    </ul>
                    <div class="price-plan-btn">Select Plan</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>

</template>
<script>
import SwiperCore, {
  Navigation,
  Parallax,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
SwiperCore.use(Navigation);

export default {
  name: "Package",
  components: {
    Swiper,
    SwiperSlide,
  
  },
  mounted() {
    let payload = {
      position: this.$refs["packagePosition"].offsetTop,
      name: "packagePosition",
    };
    this.$emit("windowPosition", payload);
  },
  data() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
      packages: [
        {
          type: "Standard",
          price: 49,
          feature1: "24/7 On-site Support",
          feature2: "real time sync",
          feature3: "unlimited attachment",
          feature4: "customize theme",
        },
        {
          type: "Premium",
          price: 59,
          feature1: "real time sync",
          feature2: "unlimited attachment",
          feature3: "customize theme",
          feature4: "priority email support",
        },
        {
          type: "Professional",
          price: 69,
          feature1: "24/7 On-site Support",
          feature2: "real time sync",
          feature3: "customize theme",
          feature4: "priority email support",
        },
        {
          type: "Extreme",
          price: 79,
          feature1: "24/7 On-site Support",
          feature2: "real time sync",
          feature3: "customize theme",
          feature4: "priority email support",
        },
        {
          type: "Standard",
          price: 49,
          feature1: "24/7 On-site Support",
          feature2: "real time sync",
          feature3: "unlimited attachment",
          feature4: "customize theme",
        },
      ],

      parallaxSwiperWidth: 0,
    };
  },
};
</script>
